var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"rounded-circle bg-white",attrs:{"href":_vm.href}},[_c('i',{class:[("fa-" + _vm.icon), 'fab', 'dark-rose-text']})])}
var staticRenderFns = []

export { render, staticRenderFns }